import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { createBrowserRouter, Outlet } from "react-router";
import { RouterProvider } from "react-router/dom";

import LayoutContainer from "./modules/app/components/LayoutContainer";
import DesktopLayoutContextProvider from "./modules/app/context/DesktopLayoutContextProvider";
import MobileLayoutContextProvider from "./modules/app/context/MobileLayoutContextProvider";
import { adminRoutes } from "./modules/app/routes";
import ErrorScreen from "./modules/app/screens/ErrorScreen";
import MainDashboardScreen from "./modules/app/screens/MainDashboardScreen";
import RequireAuth from "./modules/auth/components/RequireAuth";
import UserContextProvider from "./modules/auth/context/UserContextProvider";
import CreatePasswordScreen from "./modules/auth/screens/CreatePasswordScreen";
import Login from "./modules/auth/screens/Login";
import ResetPasswordScreen from "./modules/auth/screens/ResetPasswordScreen";
import ClientContextProvider from "./modules/client/context/ClientContextProvider";
import { clientRoutes } from "./modules/client/routes";
import { fieldworkerRoutes } from "./modules/fieldworker/routes";
import { plannerV2Routes } from "./modules/plannerV2/routes";
import ProjectContextProvider from "./modules/project/context/ProjectContextProvider";
import { userProfileRoutes } from "./modules/user/routes";

export default function App() {
    const router = createBrowserRouter([
        {
            element: (
                <RequireAuth requireLoggedOut>
                    <Outlet />
                </RequireAuth>
            ),
            children: [
                { path: "/login", element: <Login /> },
                {
                    path: "/forgot-password",
                    element: <Outlet />,
                    children: [
                        {
                            path: "",
                            element: <ResetPasswordScreen />,
                        },
                        {
                            path: ":email/:token",
                            element: <ResetPasswordScreen />,
                        },
                    ],
                },
                {
                    path: "/create-password",
                    element: <Outlet />,
                    children: [
                        {
                            path: "",
                            element: <CreatePasswordScreen />,
                        },
                    ],
                },
            ],
        },
        {
            path: "/",
            element: (
                <RequireAuth>
                    <UserContextProvider>
                        <ClientContextProvider>
                            <ProjectContextProvider>
                                <DesktopLayoutContextProvider>
                                    <MobileLayoutContextProvider>
                                        <LayoutContainer>
                                            <Outlet />
                                        </LayoutContainer>
                                    </MobileLayoutContextProvider>
                                </DesktopLayoutContextProvider>
                            </ProjectContextProvider>
                        </ClientContextProvider>
                    </UserContextProvider>
                </RequireAuth>
            ),
            errorElement: <ErrorScreen error={new Error("Reached navigation error route.")} />,
            children: [
                { index: true, element: <MainDashboardScreen /> },
                ...fieldworkerRoutes,
                ...adminRoutes,
                ...userProfileRoutes,
                ...clientRoutes,
                ...plannerV2Routes,
                {
                    path: "*",
                    element: <ErrorScreen error={new Error("Reached navigation error route.")} />,
                },
            ],
        },
    ]);

    return (
        <NuqsAdapter>
            <RouterProvider router={router} />
        </NuqsAdapter>
    );
}
